<template>
  <div class="f10-profile">
    <RkSwitch v-model="activedTab" :options="options" class="rk-switch" />
    <component :is="isComponent" />
  </div>
</template>

<script>
import RkSwitch from '@/components/common/RkSwitch.vue'
import Profile from '@/components/f10/Profile.vue'
import Shareholder from '@/components/f10/Shareholder.vue'
import Finance from '@/components/f10/Finance.vue'
import { sendMsg } from '@/plugins/msg'
const components = {
  profile: Profile,
  shareholder: Shareholder,
  finance: Finance
}
export default {
  components: {
    RkSwitch,
    Profile,
    Shareholder,
    Finance
  },
  data() {
    return {
      // activedTab: 'profile',
      options: [
        [
          { label: '公司简况', value: 'profile' },
          { label: '股东股本', value: 'shareholder' },
          { label: '财务数据', value: 'finance' }
        ]
      ]
    }
  },
  computed: {
    activedTab: {
      get() {
        return this.$route.query.activedTab || 'profile'
      },
      set(val) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            activedTab: val,
            symbol: this.$route.query.symbol
          }
        })
      }
    },
    isComponent() {
      return components[this.activedTab]
    }
  },
  watch: {
    // 改变时向父页面传递消息,使父页面记忆选中项
    activedTab(val) {
      sendMsg({ event: 'changeF10ActiveTab', active: val })
    }
  }
}
</script>

<style lang="scss" scoped>
.f10-profile {
  .rk-switch {
    padding: var(--edge-padding);
    padding-bottom: 0;
  }
}
</style>
